export default "__VITE_ASSET__ClffSRVv__"